import {isFilled} from '@prismicio/client'
import {SliceZone} from '@prismicio/react'
import type {
  ArticleDocument,
  ButtonDocument,
  CustomerStoryDocument,
  HomePageDocument,
  NavigationDocumentData,
  ProductDeepDiveDocumentData,
} from 'prismicio-types'
import {memo} from 'react'
import {components} from 'slices'
import {Layout} from 'src/common/Layout'
import {Meta} from 'src/common/Meta'
import {PageFaqSEO} from 'src/common/PageFaqSEO'
import type {Context} from 'src/common/types'

export const Home = memo(function (props: {
  navigationData: NavigationDocumentData
  page: HomePageDocument
  productDeepDiveData: ProductDeepDiveDocumentData
  buttonsData: ButtonDocument[]
  articles?: ArticleDocument[]
  customerStories?: CustomerStoryDocument[]
  customerStoriesData?: CustomerStoryDocument[]
}) {
  return (
    <Layout
      alternateLanguages={props.page.alternate_languages.map((altLang) => ({...altLang, uid: ''}))}
      breadcrumbs={props.page.data.breadcrumbs}
      navigationData={props.navigationData}
      isDarkNavigation={props.page.data.is_dark_navigation || false}
      pageUid="home-page"
      locale={props.page.lang}
    >
      <Meta
        {...(isFilled.keyText(props.page.data.meta_description) && {description: props.page.data.meta_description})}
        {...(isFilled.keyText(props.page.data.meta_title) && {title: props.page.data.meta_title})}
        {...(isFilled.image(props.page.data.meta_image) && {imageUrl: props.page.data.meta_image.url})}
      />

      <PageFaqSEO slices={props.page.data.slices} />

      <SliceZone
        components={components}
        context={
          {
            pageUid: 'home-page',
            product_deep_dive_data: props.productDeepDiveData,
            buttonsData: props.buttonsData,
            articles: props.articles ?? [],
            customerStories: props.customerStories ?? [],
            customerStoriesData: props.customerStoriesData,
          } as Context
        }
        slices={props.page.data.slices}
      />
    </Layout>
  )
})
